import DocumentPdf16 from '@carbon/icons-react/es/document--pdf/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { useTranslation } from 'hooks/use-translation';

interface Props {
  onClick: () => void;
  loading: boolean;
}
export const ExportToPdfBtn: FC<Props> = ({ onClick, loading }) => {
  const tooltip = useTranslation('document.export_pdf');

  return (
    <Tooltip title={tooltip} placement="bottom">
      <Button
        loading={loading}
        type="text"
        icon={
          <IconWrapper>
            <DocumentPdf16 />
          </IconWrapper>
        }
        size="small"
        onClick={onClick}
      />
    </Tooltip>
  );
};
